import { render, staticRenderFns } from "./DashboardVentas.vue?vue&type=template&id=7d15242b&scoped=true&"
import script from "./DashboardVentas.vue?vue&type=script&lang=js&"
export * from "./DashboardVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d15242b",
  null
  
)

export default component.exports